{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "actualSituation": "Current situation",
    "payments": "Payments",
    "totalAmount": "Total amount",
    "currentAccount": "Current account",
    "taxReturns": "$t(config.taxReturns)",
    "taxReturnsRecent": "Recent documents"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number",
    "taxReturn": "POSS return",
    "taxReturns": "POSS returns"
  },
  "payments": {
    "declaration": "Payment Declaration",
    "transaction": "Payment Transaction",
    "recordSuccess": "The payment declaration was successfully stored",
    "recordSuccessNotes": "The payment remains pending until confirmed by the collecting entity responsible for its transfer."
  },
  "taxReturns": {
    "taxReturn": "$t(config.taxReturn)",
    "reception": "$t(config.taxReturn) reception",
    "recordSuccess": "The $t(config.taxReturn) was successfully stored",
    "recordSuccessNotes": "",
    "taxReturnType": "$t(config.taxReturn) type",
    "taxReturnStatus": "Status",
    "taxReturnForm": "Form",
    "taxReturnActive": "Active"
  },
  "disable-tfa": {
    "label": {
      "title": "Disable two-factor authentication (2FA)",
      "disable": "Disable 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "This action only disables 2FA.",
      "alert-2": "Disabling 2FA does not change the keys used in authenticator apps. ",
      "alert-3": "If you wish to change the key used in an authenticator app you should:",
      "alert-4": "reset your authenticator keys.",
      "success": "2fa has been disabled. You can reenable 2fa when you setup an authenticator app"
    }
  },
  "administration-user": {
    "title": {
      "page": "Users",
      "page-taxpayer": "Taxpayers"
    },
    "label": {
      "userName": "User Name",
      "department": "Department",
      "roles": "Roles",
      "user": "New user",
      "disabled": "Disabled",
      "locale": "Preferred Language",
      "disable": "Disable",
      "enable": "Enable",
      "cancel": "Cancel"
    },
    "validations": {
      "userName": "User Name is required"
    },
    "messages": {
      "disableTitle": "Disable user",
      "confirmDisable": "Are you sure you want to disable this user?",
      "confirmEnable": "Are you sure you want to Enable this user?",
      "savedSucessfully": "Saved successfully",
      "enableTitle": "Enable user",
      "error": "Error"
    }
  },
  "user-profile": {
    "title": {
      "page": "User Profile",
      "change-password": "Change Password"
    },
    "label": {
      "userName": "User Name",
      "name": "Full Name",
      "email": "Email",
      "locale": "Preferred Language",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "repeatPassword": "Repeat password",
      "change-password": "Change Password",
      "password": "Password"
    },
    "message": {
      "password-changed": "Password changed successfully",
      "profile-updated": "Profile updated successfully. Must logout to see the changes",
      "password": "Update your account password to keep your account secure"
    }
  },
  "common": {
    "label": {
      "periodFrom": "Period from",
      "periodTo": "Period to",
      "amount": "Amount",
      "createDate": "Creation date",
      "period": "Period",
      "theme": "Theme",
      "captcha-placeholder": "Enter Captcha",
      "feedback": "Feedback",
      "logout": "Logout",
      "print": "Print",
      "phoneNumberArea": "Prefix / Area Code",
      "current-user": "Current user",
      "user-profile": "User profile",
      "givenNames": "Given names",
      "surnames": "Surname",
      "name": "Name",
      "search": "Search",
      "clean": "Clean",
      "create": "Create",
      "ok": "Ok",
      "next": "Next",
      "cancel": "Cancel",
      "back": "Back",
      "edit": "Edit",
      "actions": "Actions",
      "send": "Send",
      "close": "Close",
      "add": "Add",
      "email": "Email",
      "phoneNumber": "Phone Number",
      "id": "Id",
      "password": "Password",
      "state": "Disabled",
      "translation": "Translation",
      "language": "Language",
      "value": "Value",
      "translatable": "Translatable",
      "politicalDivision": "Political division",
      "department": "Department/Provice/State",
      "city": "City",
      "zipCode": "Zip Code",
      "cellPhone": "Cell phone",
      "personType": "Person type",
      "businessName": "Business name",
      "taxpayerName": "Full Name or Business Name",
      "tradeName": "Trading name",
      "address": "Business address",
      "country": "Country",
      "localization": "Localization",
      "website": "Website/s",
      "fileSearch": "Search file",
      "fileUpload": "Upload file",
      "fileDownload": "Download file",
      "noFileSelected": "No file selected",
      "fileRequirements": "PDF · Max. 9.6 MB",
      "fileUploading": "Uploading...",
      "fileUploaded": "Uploaded",
      "fileUploadError": "The file could not be uploaded",
      "fileSelect": "Select",
      "fileReplace": "Replace",
      "fileRemove": "Remove",
      "fileRemoving": "Removing...",
      "fileRemoveError": "The file could not be removed",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "noFound": "No results",
      "taxReturnCurrency": "$t(config.taxReturn) currency",
      "page-showing": "Showing",
      "page-to": "to",
      "page-of": "of",
      "page-entries": "entries",
      "loading": "Loading...",
      "error": "Error",
      "unableToLoad": "Unable to load data. Please try again.",
      "retry": "Retry",
      "currency": "Currency",
      "paymentMethod": "Payment method",
      "attachment": "Attachment",
      "paymentReference": "Additional information",
      "supportDocument": "Support document",
      "payment": "Payment",
      "backToHome": "Back to Home",
      "bank": "Bank",
      "bankInformation": "Bank Information",
      "excel": "Excel",
      "days": {
        "monday": "Mo",
        "tuesday": "Tu",
        "wednesday": "We",
        "thursday": "Th",
        "friday": "Fr",
        "saturday": "Sa",
        "sunday": "Su"
      },
      "months": {
        "january": "January",
        "february": "February",
        "march": "March",
        "april": "April",
        "may": "May",
        "june": "June",
        "july": "July",
        "august": "August",
        "september": "September",
        "october": "October",
        "november": "November",
        "december": "December"
      }
    },
    "descriptions": {
      "taxReturnCurrency": "Currency used for $t(config.taxReturn)",
      "contactTaxIdNumber-tax": "Tax Identification Number of the contact in the country of residence"
    },
    "button": {
      "close": "Close",
      "add": "Add",
      "edit": "Edit",
      "find": "Search",
      "cancel": "Cancel",
      "delete": "Delete",
      "save": "Save",
      "submitTaxReturn": "Submit $t(config.taxReturn)",
      "clean": "Clear",
      "new": "New",
      "show": "Show",
      "download": "Download",
      "file": "Attachment",
      "previous": "Previous",
      "next": "Next",
      "send": "Send",
      "translate": "Add translation",
      "return": "Return",
      "continue": "Continue",
      "newVersion": "New version"
    },
    "dialog": {
      "dialog-error": "Errors",
      "table-title-header": "Messages",
      "warning-title": "Attention"
    },
    "messages": {
      "error-500": "Oops, something went wrong",
      "fileUpload": "The file was uploaded successfully",
      "fileUploadMaxSize": "Document size cannot exceed 10Mb",
      "savedSucessfully": "Saved successfully",
      "deletedSucessfully": "Deleted successfully",
      "pleaseWait": "Please wait",
      "warningInactiveSession": "Attention: No activity has been detected in a while. The session will be closed in 1 minute if no activity is detected yet",
      "sessionIdleCountdown": "Your session will close in {{count}} seconds.",
      "closingSession": "Closing Session ...",
      "warningCancelOperation": "If you cancel the operation you will lose the data entered. Do you want to continue?",
      "confirm": "Are you sure you want to perform this action?",
      "feedback": "Thank you for your feedback",
      "feedbackIntro": "Your comments will be sent to the Administration to know your experience with the system and to be able to provide you with a better service.",
      "messageSent": "Message sent successfully"
    },
    "validations": {
      "nameRequired": "The field Name is required",
      "fieldRequired": "Field is required",
      "mapRequired": "You must select a position on the map",
      "numbersAndLetters": "Only numbers and letters",
      "email": "Invalid email",
      "minStringValue": "Field must be at least {{min}} characters",
      "maxStringValue": "Field must be at most {{max}} characters",
      "minNumberValue": "Field value must be at least {{min}}",
      "maxNumberValue": "Field value must be at most {{max}}",
      "urlInvalid": "Url format is invalid",
      "captchaValidationRequired": "Captcha validation is required"
    },
    "languages": {
      "spanish": "Spanish (Spain)",
      "english": "English (United States)"
    },
    "taxpayer-request-types": {
      "enroll": "Enroll",
      "update": "Update"
    },
    "taxpayer-request-states": {
      "pending": "Pending",
      "pending_additional_information": "Pending Additional Information",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Amending"
    },
    "taxreturn-status": {
      "pending": "Pending",
      "accepted": "Accepted",
      "approved": "Approved",
      "rejected": "Rejected",
      "reconciled": "Reconciled"
    },
    "yes-no": {
      "yes": "Yes",
      "no": "No"
    }
  },
  "menu": {
    "label": {
      "security": "Security",
      "users": "Users",
      "apikey": "Api Key",
      "twoFactorAuthentication": "Two Factor Authentication",
      "configuration": "Configuration",
      "notifications-application": "Notifications Application",
      "notifications-security": "Notifications Security",
      "environment-application": "Environment Application",
      "environment-security": "Environment Security",
      "operations": "Operations",
      "economy-activity": "Operation",
      "catalog": "Catalog type",
      "taxpayer-fields": "Taxpayer fields",
      "taxes": "Taxes",
      "manage-tax": "Manage Taxes"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Reconecting",
      "reconected": "Reconected"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Messages"
    },
    "label": {
      "message": "Message",
      "messages": "Messages",
      "read": "Read",
      "inboxDate": "Date",
      "ok": "Ok",
      "no": "NO"
    }
  },
  "report-file": {
    "title": {
      "page": "Attachment Suplementary report",
      "dialog": "Report already exists",
      "dialog-confirm": "Send report"
    },
    "label": {
      "header": "Header",
      "description": "Description",
      "type": "Type",
      "file": "Suplementary report",
      "loading": "Loading...",
      "definition": "Definition file (.csv,.xls,.xlsx)"
    },
    "button": {
      "attachment": "Attachment report"
    },
    "messages": {
      "dialog": "A report has already been submitted for the selected period, do you want to replace the existing report with a new version?",
      "confirm": "Are you sure you want to perform this action?",
      "successfully": "Tax Report with period [period] was sent successfuly at [createDate]",
      "backToHome": "Back to Home"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Processing",
      "error": "Error",
      "accepted": "Accepted",
      "processed": "Processed"
    },
    "title": {
      "page": "Report details"
    },
    "label": {
      "reportNumber": "Report number",
      "reportType": "Report type",
      "operations": "Operation type",
      "taxpayerNumber": "Tax payer number",
      "taxpayerName": "Tax payer Name",
      "registrationDate": "Ragistration Date",
      "period": "Period",
      "reportName": "Report Name",
      "record": "Record",
      "index": "Index",
      "type": "Type",
      "active": "Active",
      "taxReportState": "State"
    }
  },
  "report-selection": {
    "label": {
      "fileReport": "File report",
      "report": "Report",
      "year": "Period"
    },
    "messages": {
      "reportVersionNotFound": "Report version not found"
    }
  },
  "taxreturn-report": {
    "title": {
      "page": "$t(config.taxReturn) Reports"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "$t(config.taxReturn) Number",
      "country": "Country",
      "formId": "Form",
      "taxreturnType": "Operation Type",
      "taxreturnStatus": "Status",
      "name": "Taxpayer Name",
      "period": "Period",
      "periodFrom": "Period From",
      "periodTo": "Period To",
      "active": "Active",
      "overview": "Overview",
      "taxreturn": "$t(config.taxReturn)",
      "createDate": "Create Date",
      "approve": "Approved",
      "comments": "Comments"
    },
    "header": {
      "actions": "Actions",
      "nit": "TIN",
      "name": "Taxpayer Name",
      "taxReturnNumber": "$t(config.taxReturn) number",
      "createDate": "Create Date",
      "taxreturnType": "Operation Type",
      "taxreturnStatus": "Status",
      "form": "Form",
      "period": "Period",
      "active": "Active",
      "rejectionReason": "Reason for Rejection"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "form-cells": {
    "title": {
      "page": "Cells",
      "serviceParameters": "Service Parameters"
    },
    "label": {
      "code": "Cell code",
      "name": "Cell name",
      "description": "Description",
      "section": "Section",
      "formula": "Formula",
      "order": "Order",
      "type": "Type",
      "service": "Service",
      "mandatory": "Mandatory",
      "editable": "Editable",
      "visible": "Visible",
      "cellPurpose": "Cell purpose",
      "numeric": "Number",
      "currency": "Currency",
      "date": "Date",
      "list": "List",
      "text": "Text",
      "catalogType": "Catalog type",
      "parameterName": "Name",
      "addParameter": "Add parameter"
    },
    "messages": {
      "confirmTitle": "Delete",
      "confirmDeleted": "Are you sure to delete it?"
    }
  },
  "amendment-create": {
    "title": {
      "dialog-confirm": "Send $t(config.taxReturn)"
    },
    "label": {
      "taxReturn": "$t(config.taxReturn) to amend"
    },
    "messages": {
      "confirm": "Are you sure you want to perform this action?"
    }
  },
  "statement-submit-amendment": {
    "title": {
      "page": "File $t(config.taxReturn) amendment"
    },
    "label": {
      "taxReturn": "$t(config.taxReturn)",
      "year": "Period"
    },
    "messages": {},
    "validations": {},
    "button": {
      "file": "File $t(config.taxReturn) amendment"
    }
  },
  "statement-submit-statement": {
    "title": {
      "page": "File $t(config.taxReturn)",
      "subtitle": "Please complete the information to identify the tax and period to be declared"
    },
    "label": {
      "fileStatement": "File $t(config.taxReturn)",
      "taxReturn": "$t(config.taxReturn)",
      "year": "Period"
    },
    "messages": {
      "formVersionNotFound": "A current and active version was not found",
      "taxReturnExist": "$t(config.taxReturn) already exists for this period",
      "validPeriod": "The selected period is not valid for this tax"
    }
  },
  "taxreturns": {
    "title": {
      "dialog-confirm": "Send $t(config.taxReturn)"
    },
    "messages": {
      "successfully": "$t(config.taxReturn) with period [period] was sent successfuly at [createDate]",
      "successfullyApprovalRequired": "Since the amending declaration has reduced the tax, it will be submitted to a review process for approval or rejection by the tax administration.",
      "confirm": "Are you sure you want to perform this action?",
      "backToHome": "Back to Home"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Catalogs",
      "catalog": "Catalog "
    },
    "label": {
      "type": "Type",
      "name": "Name",
      "description": "Description",
      "field": "Field",
      "label": "label",
      "parent": "Parent",
      "newCatalogType": "New catalog type",
      "newCatalog": "New catalog",
      "code": "Code",
      "addDefinition": "Add definition",
      "newDefinition": "New definition",
      "extaFilds": "Additional user fields",
      "addNameTraslation": "Add translation"
    },
    "validations": {
      "exists": "The record already exists",
      "letterNumberhyphen": "Letters number and hyphens are permitted"
    },
    "messages": {
      "languageExist": "Language has already been added"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Taxpayer Fields",
      "enabled": "Enabled"
    },
    "header": {
      "fieldCode": "Code",
      "fieldName": "Field Name",
      "fieldSection": "Section Name",
      "actions": "Enabled"
    },
    "messages": {
      "savedSucessfully": "Saved successfully"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Api Keys"
    },
    "label": {
      "name": "Name",
      "new-api-key": "New Key",
      "expiration": "Expiration Date",
      "your-pat": "Your New Personal Access Token",
      "revoke-token": "Revoke Token"
    },
    "validations": {
      "name": "Api Key Name is required",
      "expiration": "Expiration Date is required"
    },
    "message": {
      "key-created": "Make sure you save it - you won't be able to access it again.",
      "confirm-revoke": "Are you sure do you want to revoke the token?"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Configure authenticator app",
      "verification-code": "Verification Code",
      "verification-code-digit": "Digit {{position}} of {{total}}",
      "verify": "Verify",
      "manual-key": "Manual setup key",
      "copy-key": "Copy key",
      "key-copied": "Key copied to clipboard.",
      "key-copied-button": "Copied",
      "copy-unavailable": "The key could not be copied. Copy it manually.",
      "security-recommendations": "Security recommendations",
      "security-recommendations-detail": "Keep recovery codes in a safe place and do not share the setup key."
    },
    "validations": {
      "code": "Verification Code is required"
    },
    "message": {
      "instruction-1": "Download a two-factor authenticator app like Microsoft Authenticator for",
      "and": "and",
      "or": "or",
      "for": "for",
      "instruction-2": "Scan the QR Code or enter this key",
      "instruction-3": "into your two factor authenticator app. Spaces and casing do not matter.",
      "instruction-4": " Once you have scanned the QR code or input the key above, your two factor authentication app will provide you with a unique code. Enter the code in the confirmation box below."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Recovery codes",
      "available-once": "Save them now: they will not be shown in full again."
    },
    "message": {
      "save-security-codes": "Put these codes in a safe place.",
      "if-you-lose": "If you lose your device and don't have the recovery codes you will lose access to your account."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Generate two-factor authentication (2FA) recovery codes",
      "generate": "Generate Recovery Codes"
    },
    "validations": {},
    "message": {
      "alert-1": "Put these codes in a safe place.",
      "alert-2": " If you lose your device and don't have the recovery codes you will lose access to your account.",
      "alert-3": "Generating new recovery codes does not change the keys used in authenticator apps. If you wish to change the key used in an authenticator app you should",
      "alert-4": "reset your authenticator keys."
    }
  },
  "security-login": {
    "title": {
      "login": "Login"
    },
    "label": {
      "username": "Username",
      "password": "Password",
      "rememberMe": "Remember me",
      "loginButton": "Login",
      "passwordRecovery": "Recover password",
      "notRegistered": "Not registered yet ?",
      "signup": "Sign up now",
      "loginAlternative": "or",
      "forgotPassword": "Forgot your password?",
      "next": "Next",
      "forgotPasswordInstructions": "Enter your user name and we will send you a mail with detailed instructions to recover it",
      "externalLogin": "External Login",
      "captcha-placeholder": "Enter Captcha"
    },
    "validations": {
      "usernameRequired": "The field Username is required",
      "passwordRequired": "The field Password is required",
      "captchaValidationRequired": "Captcha validation is required"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Two-factor authentication",
      "login-recovery": "Recovery code verification"
    },
    "label": {
      "twoFactorCode": "Authenticator code",
      "recoveryCode": "Recovery code",
      "rememberBrowser": "Remember this browser",
      "verificationCodeInstructions": "Enter the six-digit code from your authenticator app to continue.",
      "loginButton": "Login",
      "loginRecovery": "Login with a recovery code"
    },
    "message": {
      "no-access": " Don't have access to your authenticator device? You can",
      "trustedBrowser": "Skip verification on this trusted browser.",
      "recovery-requested": " You have requested to log in with a recovery code. This login will not be remembered until you provide an authenticator app code at log in or disable 2FA and log in again."
    },
    "validations": {
      "twoFactorCode": "The field Authenticator code is required",
      "recoveryCode": "The field Recovery code is required"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Recover Password",
      "changePassword": "Change password",
      "userName": "User Name",
      "newPassword": "New password",
      "repeatPassword": "Repeat password",
      "returnLogin": "Return to Login"
    },
    "message": {
      "email-sended": "Recover password email sended",
      "password-changed": "Password changed successfully"
    },
    "validations": {
      "newPassword": "New password must be at least 6 characters",
      "passwordEqual": "Password does not match"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Setup authenticator app",
      "reset": "Reset authenticator key",
      "configure": "Configure authenticator app"
    },
    "validations": {},
    "message": {
      "alert-1": "If you reset your authenticator key your authenticator app will not work until you reconfigure it.",
      "alert-2": "This process disables 2FA until you verify your authenticator app.",
      "alert-3": "If you do not complete your authenticator app configuration you may lose access to your account.",
      "success": "Your authenticator app key has been reset, you will need to configure your authenticator app using the new key."
    }
  },
  "tfa": {
    "title": {
      "page": "Two Factor Authentication"
    },
    "label": {
      "title": "Two-factor authentication (2FA)",
      "authenticator-app": "Authenticator app",
      "setup-authenticator": "Setup authenticator app",
      "add-authenticator": "Add authenticator app",
      "reset-authenticator": "Reset authenticator app",
      "reset-recovery-codes": "Reset recovery codes",
      "disable-2fa": "Disable 2FA",
      "forget-this-browser": "Forget this browser",
      "status-enabled": "Enabled",
      "status-disabled": "Not configured",
      "recovery-codes-remaining": "recovery codes available",
      "danger-zone": "High-impact actions"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "The current browser has been forgotten. When you login again from this browser you will be prompted for your 2fa code.",
      "no-codes-left-1": "You have no recovery codes left.",
      "no-codes-left-2": "You must",
      "no-codes-left-3": "generate a new set of recovery codes",
      "no-codes-left-4": "before you can log in with a recovery code.",
      "some-codes-left-1": "You have",
      "some-codes-left-2": "recovery codes left.",
      "some-codes-left-3": "You should ",
      "some-codes-left-4": "generate a new set of recovery codes"
    }
  },
  "roles": {
    "account_reports": "Account Reports",
    "catalogs_admin": "Catalogs Administrator",
    "details_reports": "Details Reports",
    "environments_admin": "Environment Administrator",
    "forms_admin": "Forms Administrator",
    "management_report_admin": "Management Reports Administrator",
    "notifications_admin": "Notifications Administrator",
    "system_auditor": "System Auditor",
    "taxpayer_reports": "Taxpayer Reports",
    "taxpayers_admin": "Taxpayers Administrator",
    "payments_admin": "Payment Manager",
    "taxpayers_approver": "Taxpayers Approver",
    "taxreturn_approver": "$t(config.taxReturn) Approver",
    "taxreturn_reports": "$t(config.taxReturn) Reports",
    "tfa_admin": "2FA Administrator",
    "users_admin": "Users Administrator",
    "current_account_admin": "Current Account Manager",
    "debt_collection_analyst": "Debt collection analyst",
    "debt_collection_manager": "Debt collection manager",
    "debt_collection_officer": "Debt collection officer",
    "taxpayer_communication": "Communication to the taxpayer",
    "non_compliance_analyst": "Non compliance analyst",
    "collection_statistics": "Collection analysis",
    "compliance_statistics": "Non compliance analysis",
    "disbursement_view": "View disbursements",
    "disbursement_manage": "Manage disbursements"
  },
  "taxes": {
    "title": {
      "page": "Manage Taxes"
    },
    "label": {
      "name": "Name",
      "rateType": "Rate Type",
      "shortName": "Short Name",
      "code": "Code",
      "newButton": "New",
      "saveButton": "Save",
      "tabEditTax": "General",
      "tabRates": "Rates",
      "tabPeriodicity": "Periodicity",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "value": "Value",
      "periodicityType": "Periodicity Type",
      "filingDueDay": "Filing Due Day"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "rateType": "Rate Type",
      "value": "Value",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "shortName": "Short Name",
      "actions": "Actions",
      "periodicityType": "Periodicity Type",
      "filingDueDay": "Filing Due Day"
    },
    "validations": {
      "rateTypeRequired": "The field Rate Type is required",
      "shortNameRequired": "The field Short Name is required",
      "codeRequired": "The field Code is required",
      "valueLessThan100": "The field Value should be less thant 100%",
      "valueRequired": "The field Value is required",
      "dateFromRequired": "The field Date From is required",
      "dateToRequired": "The field Date To is required",
      "filingDueDayRequired": "The field Filing Due Day is required",
      "periodicityTypeRequired": "The field Periodicity Type is required"
    },
    "messages": {
      "savedSuccessfully": "Saved successfully",
      "deletedSuccessfully": "Deleted successfully",
      "error": "Error"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Manage Report Operations",
      "warning": "Warning"
    },
    "label": {
      "operation": "Operation",
      "report": "Report"
    },
    "header": {
      "operation": "Operation",
      "report": "Report",
      "actions": "Actions"
    },
    "messages": {
      "removeReportOperation": "Are you sure delete it?"
    }
  },
  "report-cells": {
    "title": {
      "page": "Cells"
    },
    "label": {
      "code": "Cell code",
      "name": "Cell name",
      "description": "Description",
      "formula": "Formula",
      "order": "Order",
      "type": "Type",
      "numeric": "Numeric",
      "currency": "Currency",
      "date": "Date",
      "list": "List",
      "text": "Text",
      "catalogType": "Catalog Type"
    },
    "messages": {
      "confirmTitle": "Delete",
      "confirmDeleted": "Are you sure do you want to delete it?"
    }
  },
  "reports": {
    "title": {
      "page": "Manage Reports",
      "report": "Report",
      "versions": "Versions"
    },
    "label": {
      "name": "Name",
      "shortName": "Short Name",
      "code": "Code",
      "newButton": "New",
      "saveButton": "Save",
      "tabEditReport": "General",
      "tabPeriodicity": "Periodicity",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "periodicityType": "Periodicity Type",
      "filingDueDay": "Filing Due Day"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "shortName": "Short Name",
      "actions": "Actions",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "periodicityType": "Periodicity Type",
      "filingDueDay": "Filing Due Day"
    },
    "validations": {
      "shortNameRequired": "The field Short Name is required",
      "codeRequired": "The field Code is required",
      "dateFromRequired": "The field Date From is required",
      "dateToRequired": "The field Date To is required",
      "filingDueDayRequired": "The field Filing Due Day is required",
      "periodicityTypeRequired": "The field Periodicity Type is required"
    },
    "messages": {
      "savedSuccessfully": "Saved successfully",
      "deletedSuccessfully": "Deleted successfully",
      "error": "Error"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Current Account",
      "amendingCredit": "Balance inquiry",
      "currentAccountTransaction": "Transactions detail",
      "transactionAdjustment": "Balance adjustment"
    },
    "label": {
      "tax": "Tax",
      "taxCode": "Tax code",
      "period": "Period",
      "taxAmount": "Tax amount",
      "penalty": "Penalty",
      "interest": "Interest",
      "taxArrears": "Tax arrears",
      "total": "total",
      "expirationDate": "Expiration date",
      "accountType": "Account type",
      "balance": "Balance",
      "date": "Date",
      "transactionType": "Transaction type",
      "value": "Value",
      "document": "Document",
      "justification": "Justification",
      "credit": "Credit",
      "debit": "Debit"
    },
    "dialog": {},
    "messages": {},
    "validations": {}
  },
  "taxpayer-payments": {
    "title": {
      "page": "View payments",
      "pagePayments": "Record payment",
      "selectTaxReturn": "Select $t(config.taxReturn)"
    },
    "label": {
      "registerPayment": "Record payment",
      "amountTaxReturn": "Declaration amount",
      "amountBank": "Bank amount",
      "totalDebt": "Total debt",
      "tax-id": "Tax identification",
      "name": "Name",
      "date-from": "Date from",
      "date-to": "Date to",
      "date-payment": "Payment date",
      "payment-number": "Payment number",
      "exchange-rate": "Exchange rate.",
      "local-amount": "Amount in local currency",
      "tax": "Tax",
      "amount": "Amount",
      "swiftNumber": "Swift confirmation number",
      "date-payment-bank": "Date received"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Payment successfully registered on [createDate]",
      "paymentInformationWarning": "If the information concerning the Swift code is not provided, the payment cannot be correctly identified and the declaration will be considered unpaid"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Taxpayes list"
    },
    "label": {
      "name": "Name",
      "nit": "TIN",
      "county": "Country",
      "personType": "Person type",
      "email": "Email"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Person",
      "businessName": "Business name",
      "fullName": "Full name",
      "id": "Identity card number",
      "taxNumber": "Tax Identification Number in the country of residence",
      "phoneNumber": "Phone number",
      "domicile": "Domicile",
      "department": "Department/Provice/State",
      "addContact": "Add contact",
      "operations": "Operations",
      "contacts": "Contacts",
      "taxVector": "Tax vector",
      "reportVector": "Report",
      "generalData": "General",
      "tax": "Tax",
      "taxObligation": "Tax",
      "report": "Report",
      "website": "Web site",
      "idTax": "Tax Identification Number in the country of residence",
      "contactName-tax": "Main Contact Name",
      "docNumberContact-tax": "Contact Identity card number",
      "contactTaxIdNumber-tax": "Tax Identification Number of the contact in the country of residence",
      "phoneNumberContact-tax": "Contact phone number in country of residence",
      "email-tax": "Contact E-Mail",
      "documents": "Documents",
      "docCompanyRegistrationNumber": "Company registration document",
      "docLocalContact": "Local contact registered identity",
      "acceptance": "Acceptance",
      "taxpayerRequest": "POSS registration",
      "confirmTerms": "Accept the terms and conditions",
      "terms": "Lorem ipsum dolor sit amet consectetur adipiscing elit per, penatibus euismod ac libero praesent sollicitudin lacinia nulla platea, nam hac cursus cubilia congue luctus dapibus. Iaculis luctus egestas accumsan eleifend metus dis aptent quisque, lacus vitae nullam habitasse ad mollis tempor, mattis ornare dapibus laoreet auctor tellus dui. Ante integer sagittis erat accumsan vulputate potenti senectus, rutrum ullamcorper nam hendrerit ridiculus faucibus, parturient fames ligula venenatis tristique inceptos.\n\nCum aliquet tempor cras non potenti inceptos aptent, mauris scelerisque mollis auctor libero porta id ut, sodales vulputate eget imperdiet netus posuere. Iaculis dignissim himenaeos magna luctus nulla egestas porttitor, eros vulputate volutpat sociosqu quisque mollis donec, class placerat justo vivamus imperdiet accumsan. Ultrices facilisi phasellus augue cursus etiam viverra suspendisse est, nam vulputate tempor posuere dignissim feugiat sed hac sodales, diam tristique pretium auctor ad erat sem. Et enim gravida magnis malesuada nam nascetur fermentum, proin platea elementum nec penatibus ultricies, blandit cubilia aptent neque praesent sociis.\n\nSagittis augue enim nam sociis, ornare est mi himenaeos, risus proin sodales. Proin malesuada integer aliquam cubilia neque natoque velit, feugiat elementum quis quisque suscipit fermentum conubia, nisi a ligula duis sapien tellus. Praesent mattis fringilla habitant nulla sollicitudin bibendum habitasse at cum quis mus iaculis mi magna sodales, velit hendrerit inceptos dictum neque montes turpis tellus nam morbi commodo nullam senectus.\n\nArcu primis eu conubia fusce nisi vehicula posuere leo sollicitudin eleifend, phasellus sodales congue ligula consequat volutpat magnis facilisi curabitur maecenas, et dis velit libero hac proin habitant sociis nascetur. Nunc tortor penatibus mi ultrices risus nec elementum justo, mattis ad ac tempus vel habitasse accumsan sed parturient, lectus lacinia conubia malesuada volutpat egestas nulla. Himenaeos consequat vitae class mattis taciti nec habitant eleifend, elementum netus eget parturient suspendisse porttitor in felis maecenas, curabitur morbi odio gravida vivamus per bibendum.\n\nTortor non sociosqu accumsan orci vel ligula risus nisl, penatibus odio magnis ullamcorper pellentesque habitant lacinia consequat, aptent nec congue nisi egestas sociis quam. Turpis sociis eu est parturient in fames aliquet nisl, dui natoque phasellus aliquam posuere curae aptent porta, tortor condimentum molestie netus cubilia inceptos lacinia. Auctor laoreet purus nostra dapibus sollicitudin tincidunt dictum nisl lacinia erat, est rhoncus fusce phasellus blandit etiam inceptos suspendisse magna, duis pellentesque nam hac neque mus dignissim a enim.\n\nNeque proin felis laoreet senectus nullam netus sollicitudin odio tincidunt, penatibus parturient facilisis porta duis sagittis malesuada varius sociosqu congue, aptent velit pellentesque mauris egestas nibh semper orci. Dis sociosqu at torquent nec commodo erat eu pharetra natoque, senectus velit nascetur curae sollicitudin mus phasellus. Aenean diam ut nibh vulputate neque fusce penatibus class porta mattis imperdiet risus ante, ac lectus habitasse posuere facilisis luctus varius mus tempus non mollis.\n\nDictumst eleifend vehicula purus hendrerit volutpat primis integer, per senectus fusce nulla cubilia dictum feugiat auctor, ultricies sociosqu nisl mi class magnis. Ligula himenaeos phasellus pulvinar accumsan platea egestas sodales hendrerit sagittis augue, curae nec molestie pretium cum parturient lacus euismod sociosqu ullamcorper duis, dignissim fusce libero maecenas congue lobortis penatibus nisi justo.\n\nCum rutrum vehicula convallis pellentesque maecenas nascetur proin congue platea, posuere neque facilisi ullamcorper nibh curae sodales non, cursus nisl cras morbi interdum vitae auctor cubilia. Ligula taciti enim donec congue bibendum fusce eros rhoncus suscipit, dui parturient potenti odio sapien non erat eget, tincidunt convallis primis quam tortor consequat sodales per. Neque hendrerit erat nunc hac ullamcorper molestie fermentum, tristique ultrices sociis vivamus volutpat lectus, vestibulum vehicula aenean mattis magna posuere. Justo condimentum tempor taciti laoreet inceptos per hendrerit eleifend consequat lacus nostra enim, convallis praesent dui faucibus lobortis quam pharetra odio mauris duis.\n\nMagna ultrices dui netus laoreet odio rhoncus maecenas nec placerat rutrum, massa duis nam nulla velit quis fringilla habitasse. Eu integer diam lectus ullamcorper torquent ante aliquet cras feugiat inceptos placerat ut, porta libero nam mauris volutpat habitasse iaculis lacinia facilisi hendrerit nostra.\n\nLaoreet risus nisi sociosqu inceptos maecenas blandit phasellus bibendum, nostra velit fringilla tristique mus donec lectus semper, est tortor nascetur curae scelerisque himenaeos sagittis. Quam volutpat eros non nec nascetur justo, velit tristique nisl arcu est, ultricies sapien convallis metus vulputate. Condimentum justo ad varius habitant nunc gravida sed vivamus, maecenas ut congue aenean ligula proin lectus, natoque urna duis dui semper egestas habitasse.\n\nAnte et luctus porta malesuada accumsan cursus senectus dictumst penatibus pretium nullam, id condimentum proin felis aliquam sollicitudin varius velit lobortis class placerat, praesent ridiculus eget nisl metus tristique maecenas semper himenaeos parturient. Enim laoreet vulputate orci dui lectus purus bibendum vivamus posuere est curabitur, cubilia fames nulla porta in scelerisque cursus nunc a ligula pretium dictum, mi molestie pulvinar torquent litora vitae fusce eget curae sem. Dapibus quam facilisi cras pharetra mus curabitur, parturient a malesuada integer vitae etiam suspendisse, fermentum massa libero curae neque.",
      "locale": "Preferred Language",
      "close": "Close",
      "acquirerId": "Acquirer ID",
      "acquirerCountry": "Acquirer country",
      "terminalId": "Terminal ID",
      "merchantCategoryCode": "Merchant category code",
      "merchantId": "Merchant ID",
      "documentNumberCountryResidence": "Document number in the country of residence"
    },
    "vector": {
      "label": {
        "tax": "Tax",
        "expiration": "Filing Due Day",
        "periodicity": "Periodicity",
        "startOperation": "Registration Start Date"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "More contacts are required",
      "operations": "At least one operation is required",
      "selectOperations": "Type of Supplies",
      "withoutOperations": "No operations",
      "withoutOperationsVector": "For your selected operations you do not have a tax vector to present",
      "withoutOperationsReport": "For your selected operations you do not have reports to present",
      "withoutDocuments": "There is no file definition",
      "successRegistrationTaxpayerTitle": "Your registration request has been completed and received succesfully.",
      "successRegistrationTaxpayerSubTitle": "It will be analyzed and you will get their results by mail",
      "email-tax-info": "This email will be used to receive your username and password once your application is approved. Please verify that the information provided is correct.",
      "contactsList": "Register your secondary contacts here. You must register at least one",
      "noContacts": "No contacts have been specified"
    },
    "validations": {
      "acceptance": "Field must be checked",
      "formComplete": "Complete the entire form"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Taxpayer Requests",
      "approve": "Approve Request",
      "reject": "Reject Request",
      "request-additional-info": "Request Additional Information"
    },
    "label": {
      "date-from": "Date From",
      "date-to": "Date To",
      "request-type": "Request Type",
      "request": "Request",
      "type": "Type",
      "taxpayer": "Taxpayer",
      "state": "State",
      "approve": "Approve",
      "reject": "Reject",
      "request-additional-info": "Request Additional Information",
      "comments": "Comments",
      "reason": "Reason",
      "cancellationDate": "Cancellation date"
    },
    "message": {
      "approved": "Request Approved",
      "rejected": "Request Rejected",
      "request-additional-info": "Additional Information Requested",
      "unsubscribe-request": "Your application has been received, you will be notified if your application was approved or rejected."
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "View $t(config.taxReturns)",
      "subtitle": "List of stored documents",
      "amendment": "File $t(config.taxReturn) amendment"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "$t(config.taxReturn) Number",
      "country": "Country",
      "formId": "Form Name",
      "taxreturnType": "Operation Type",
      "taxreturnStatus": "Status",
      "name": "Taxpayer Name",
      "period": "Period",
      "periodFrom": "Period From",
      "periodTo": "Period To",
      "active": "Active",
      "overview": "Overview",
      "taxreturn": "$t(config.taxReturn)",
      "createDate": "Creation Date",
      "approve": "Approved",
      "comments": "Comments"
    },
    "header": {
      "actions": "Actions",
      "nit": "$t(config.tin)",
      "name": "Taxpayer Name",
      "taxReturnNumber": "$t(config.taxReturn) Number",
      "createDate": "Creation Date",
      "taxreturnType": "Operation Type",
      "taxreturnStatus": "Status",
      "form": "Form",
      "period": "Period",
      "active": "Active",
      "rejectionReason": "Reason for Rejection"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Update registration"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Unsuscribe"
    }
  },
  "form-administration": {
    "title": {
      "page": "Tax Statement Form Administration ",
      "form": "Form",
      "versions": "Versions"
    },
    "label": {
      "code": "Code",
      "name": "Name",
      "shortName": "Short name",
      "tax": "Tax",
      "numberModifications": "Number Modifications",
      "amendmentApprovalRequired": "Amendment Approval Required",
      "form": "Forms",
      "versions": "Versions"
    },
    "header": {
      "actions": "Actions",
      "code": "Code",
      "name": "Name",
      "shortName": "Short name",
      "tax": "Tax"
    },
    "messages": {
      "confirmTitle": "Delete",
      "confirmDeleted": "Are you sure deleted?",
      "noCellDefined": "Dear taxpayer this form has an incomplete definition, contact the administrator"
    }
  },
  "taxpayer-alternate-user": {
    "title": {
      "page-add": "New alternate user",
      "page-list": "Alternate users"
    },
    "label": {
      "add-user": "Add user"
    }
  },
  "login": {
    "hero": {
      "title": "Modernization and Cooperation for the Challenges of Taxation in the",
      "name": "Digital Economy"
    },
    "block1": {
      "title": "A Strategic Platform",
      "text": "for Tax Administrations"
    },
    "block2": {
      "title": "An Effective Tool",
      "text": "for Managing the Taxation of Companies Without Physical Representation in the Jurisdiction."
    },
    "block3": {
      "title": "Designed to Facilitate",
      "text": "the Registration, Filing, and Payment of Taxes by Foreign Digital Suppliers."
    },
    "links": {
      "title": "More Information",
      "link1": "Materials and Procedures",
      "link2": "About CIAT",
      "link3": "About PITAA"
    }
  },
  "appMenu": {
    "taxpayer-profile-update": "Update registration",
    "taxpayer-payment-view": "View payments",
    "unsubscribe-request-taxpayer": "Unsubscribe",
    "taxpayer-payment-record": "Record payment",
    "taxpayer-amending-credit": "View Transactions",
    "security-taxpayer": "Security",
    "apikey": "Api Keys",
    "two-factor-authentication-taxpayer": "Two Factor Authentication",
    "taxpayer-profile": "Profile",
    "inbox-notifications": "Notifications",
    "messages": "Messages",
    "file-tax-statements": "Submit $t(config.taxReturn)",
    "statements": "$t(config.taxReturns)",
    "taxpayer-taxreturn-payments": "Payments",
    "file-report": "Submit Supplementary Report",
    "amendment-taxreturn": "Amend $t(config.taxReturn)",
    "taxpayer-tax-returns": "View $t(config.taxReturns)",
    "taxpayer-report-details": "View Supplementary Reports",
    "taxpayer-current-account": "Current Account"
  }
}
